import React from "react";
import PageBanner from "../../components/PageBanner";
import { useLanguage } from "../../i18n/LanguageContext";

const BlogBanner: React.FC = () => {
  const { t } = useLanguage();

  return <PageBanner title={t.blog.title} subtitle={t.blog.subtitle} />;
};

export default BlogBanner;
